import React, { useState } from "react";

import { OutlinedTextFieldProps } from "@mui/material";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTime } from "luxon";

interface DatePickerProps {
  defaultDateSelection?: Date;
  disabled?: boolean;
  // eslint-disable-next-line
  minDate?: any;
  // eslint-disable-next-line
  maxDate?: any;
  // eslint-disable-next-line
  onChange: (date: any, value: string) => void;
  label?: string;
  size?: "small" | "medium" | undefined;
}

interface DatePickerTextFieldProps extends OutlinedTextFieldProps {
  "data-testid"?: string;
}

const DatePicker = ({
  defaultDateSelection,
  disabled,
  minDate,
  maxDate,
  onChange,
  label,
  size,
}: DatePickerProps) => {
  const [selectedPickerDate, setSelectedPickerDate] = useState<Date | null>(
    defaultDateSelection ? new Date(defaultDateSelection) : new Date()
  );

  // eslint-disable-next-line
  const onDateChange = (date: DateTime | null, value?: any) => {
    const newDateTime = date ? date.toJSDate() : null;
    const currentTime = DateTime.now().toJSDate();

    if (newDateTime) {
      newDateTime.setHours(
        defaultDateSelection
          ? defaultDateSelection.getHours()
          : currentTime.getHours()
      );
      newDateTime.setMinutes(
        defaultDateSelection
          ? defaultDateSelection.getMinutes()
          : currentTime.getMinutes()
      );
      newDateTime.setSeconds(
        defaultDateSelection
          ? defaultDateSelection.getSeconds()
          : currentTime.getSeconds()
      );
      newDateTime.setMilliseconds(
        defaultDateSelection
          ? defaultDateSelection.getMilliseconds()
          : currentTime.getMilliseconds()
      );
    }

    setSelectedPickerDate(newDateTime);
    onChange(newDateTime, value);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DesktopDatePicker
        label={label || ""}
        minDate={minDate ? DateTime.fromJSDate(minDate) : undefined}
        maxDate={maxDate ? DateTime.fromJSDate(maxDate) : undefined}
        value={
          selectedPickerDate ? DateTime.fromJSDate(selectedPickerDate) : null
        }
        onChange={onDateChange}
        slotProps={{
          textField: {
            size: size,
            "data-testid": "date-picker-input-field",
          } as DatePickerTextFieldProps,
        }}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
